import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
  ApolloLink,
} from "@apollo/client";

import { onError } from "@apollo/client/link/error";
import { setContext } from "@apollo/client/link/context";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import "react-modern-drawer/dist/index.css";
import authStore from "stores/authStore";
import { clearAccessToken, getAccessToken } from "auth/token";

const handleAuthError = () => {
  clearAccessToken(); // NEW: also clear the cookie
  authStore.setIsAuthenticated(false);
  window.location.href = "/";
};

const errorLink = onError(({ graphqlErrors }) => {
  if (graphqlErrors) {
    graphqlErrors.map(({ message }) => {
      alert(`Graphql error ${message}`);
    });
  }
});

const authResponseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    // Only protocol-level GraphQL errors count here — scanning response.data
    // as well causes false positives whenever legitimate content (e.g. a
    // BadRequest message for an optional-auth field) happens to contain this
    // wording, forcing out users who are still validly logged in.
    const hasAuthError = response.errors?.some((err) => {
      const message = err.message?.toLowerCase() || "";
      return (
        message.includes("not authenticated") ||
        message.includes("token expired") ||
        message.includes("unauthorized")
      );
    });

    // Deliberately not gated on getAccessToken() — Pages (routes/index.js)
    // isn't a MobX observer, so setIsAuthenticated(false) alone can't repaint
    // it. The hard redirect below is what actually clears a stuck private
    // route once the cookie is already gone, so it must still fire in that case.
    if (hasAuthError) {
      handleAuthError();
    }

    return response;
  });
});

// NEW: inject Authorization header from cookie
const authLink = setContext((_, { headers }) => {
  const token = getAccessToken();
  return {
    headers: {
      ...headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  };
});

const link = from([
  authResponseLink,
  errorLink,
  authLink,
  new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_URL,
    credentials: "include",
    fetchOptions: {
      credentials: "include",
    },
  }),
]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,

  // link: authLink.concat(link),
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ApolloProvider client={client} className="font-sans">
    <Router>
      <App />
    </Router>
  </ApolloProvider>,
);
